import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import ClientNotes from "../../../../../modules/clientNotes/ClientNotes";
import { useNotesModalStore } from "../../../../../modules/Common/ClientNoteTrigger/store/useNotesModalStore";
import FollowUpHistory from "../../../../../modules/FollowUps/followup-history/FollowUpHistory";
import CallLog from "../CallLog";
import CaseFollowUps from "../FollowUps/CaseFollowUps";

import a11yProps from "./a11yProps";
import TabPanel from "./TabPanel";

export default function TabClientNotesCallLog({
  canViewCallLog,
  canViewFollowUps,
  canViewNotes,
  caseObj,
}) {
  const [tabValue, setTabValue] = useState(0);
  const [parentHeight, setParentHeight] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const openModal = useNotesModalStore((state)=>state.openModal);

  useEffect(() => {
  if (location.state?.openNotesAdd) {
    const idx = getArray().findIndex(t => t.title === "Client Notes");
    if (idx !== -1) {
      setTabValue(idx);
      openModal();
      navigate(location.pathname, { replace: true, state: {} });
    }
  }
  }, [location.state]);

  const changeParentHeight = () => {
    const el = document.getElementById("simple-tabpanel-1");
    if (el) {
      setParentHeight(el.offsetHeight);

      const resizeObserver = new ResizeObserver(() => {
        setParentHeight(el.offsetHeight);
      });
      resizeObserver.observe(el);

      return () => resizeObserver.disconnect();
    }
  };

  useEffect(() => {
    changeParentHeight();
  }, [caseObj, location.pathname]);

  const tabData = [
    {
      title: "Follow-ups",
      permission: canViewFollowUps,
      a11yPropsIndex: 0,
      style: "w-2/3",
      component: (
        <div className="relative flex flex-col h-full p-2">
          <div>
            <CaseFollowUps
              clientId={caseObj?.client?.pk ?? caseObj?.client?.id}
              caseId={caseObj?.pk ?? caseObj?.id}
              lawFirmId={caseObj?.lawFirm}
            />
          </div>
          <div className="relative flex-1 w-full overflow-hidden">
            <FollowUpHistory caseObj={caseObj} />
          </div>
        </div>
      ),
    },
    {
      title: "Client Notes",
      permission: canViewNotes,
      a11yPropsIndex: 0,
      style: "w-2/3",
      component: (
        <div className="max-h-[100%] rounded-md h-full">
          <ClientNotes caseObj={caseObj} parentHeight={parentHeight} />
        </div>
      ),
    },
    {
      title: "Call Log",
      permission: canViewCallLog,
      a11yPropsIndex: 0,
      style: "w-2/3",
      component: (
        <div className="rounded-md">
          <CallLog />
        </div>
      ),
    },
  ];

  const getArray = () =>
    tabData.reduce((acc, curr) => {
      if (curr.permission) {
        acc.push(curr);
      }
      return acc;
    }, []);

  return (
    <div className="flex flex-col flex-1">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          padding: "0",
        }}
      >
        <Tabs
          id="tab-header"
          value={tabValue}
          onChange={(_, val) => setTabValue(val)}
          aria-label="Communication Panel"
          className="justify-between"
          variant="fullWidth"
          TabIndicatorProps={{ sx: { backgroundColor: "#9333EA" } }}
          sx={{
            "& button.Mui-selected": {
              color: `#9333EA`,
            },
            ".Mui-selected": {
              color: `#9333EA`,
            },
            ".MuiBox-root.div": {
              padding: 0,
            },
          }}
        >
          {getArray().map((tab, idx) => {
            return (
              <Tab
                key={idx}
                label={tab.title}
                {...a11yProps(tab.a11yPropsIndex)}
                className={tab.style}
              />
            );
          })}
        </Tabs>
      </Box>
      {getArray().map((tab, idx) => {
        return (
          <TabPanel key={idx} value={tabValue} index={idx} className="flex-1">
            {tab.component}
          </TabPanel>
        );
      })}{" "}
    </div>
  );
}
